import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberBusinessinterruption = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M.92 9.02a6.67 6.67 0 0 1 6.67-6.67h48.83a6.67 6.67 0 0 1 6.67 6.67v36.01a6.67 6.67 0 0 1-6.67 6.67h-8.68a1 1 0 1 1 0-2h8.68a4.67 4.67 0 0 0 4.67-4.67V9.02a4.67 4.67 0 0 0-4.67-4.67H7.59a4.67 4.67 0 0 0-4.67 4.67v36.01a4.67 4.67 0 0 0 4.67 4.67h9.44a1 1 0 1 1 0 2H7.59a6.67 6.67 0 0 1-6.67-6.67z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M1.09 14.52a1 1 0 0 1 1-1h60a1 1 0 1 1 0 2h-60a1 1 0 0 1-1-1M47.81 7.97a1.08 1.08 0 1 0 0 2.16 1.08 1.08 0 0 0 0-2.16m-3.08 1.08a3.08 3.08 0 1 1 6.16 0 3.08 3.08 0 0 1-6.16 0M55.97 7.97a1.08 1.08 0 1 0 0 2.16 1.08 1.08 0 0 0 0-2.16m-3.08 1.08a3.08 3.08 0 1 1 6.16 0 3.08 3.08 0 0 1-6.16 0M39.66 7.97a1.08 1.08 0 1 0 0 2.16 1.08 1.08 0 0 0 0-2.16m-3.08 1.08a3.08 3.08 0 1 1 6.16 0 3.08 3.08 0 0 1-6.16 0M21.904 26.85a1 1 0 0 1 .866-.5h19.22a1 1 0 0 1 .866.5l9.62 16.65a1 1 0 0 1 0 1l-9.62 16.65a1 1 0 0 1-.866.5H22.77a1 1 0 0 1-.866-.5l-9.61-16.65a1 1 0 0 1 0-1zm1.443 1.5L14.315 44l9.032 15.65h18.066L50.455 44l-9.042-15.65z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M24.563 36.173a1 1 0 0 1 1.414 0l14.23 14.24a1 1 0 1 1-1.414 1.414l-14.23-14.24a1 1 0 0 1 0-1.415",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M40.207 36.173a1 1 0 0 1 0 1.414l-14.23 14.24a1 1 0 1 1-1.414-1.414l14.23-14.24a1 1 0 0 1 1.414 0",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberBusinessinterruption;
